import markDeclareService from "./markDeclareService";

const processingMarkDeclareService = [
    ...markDeclareService
]

export default processingMarkDeclareService;